export { default } from './BreakingDealsContainerMobile';
